// mockProductionMilestonesData.js
// Mock data for the Production Milestones page.
// Place at: src/mockData/mockProductionMilestonesData.js

// ─── Summary KPIs ────────────────────────────────────────────────────────────

export const PRODUCTION_SUMMARY = {
  totalModulesInProduction: 142,
  buildings: [
    "Flatz 480 - Building 5",
    "Flatz 480 - Building 6",
    "Flatz 326 - PROTO",
  ],
  ytdCompletionAmt: 100,
  ytdCompletionTarget: 90,
  onTimeDeliveryPct: 91.2,
  onTimeDeliveryTarget: 95.0,
  completionVariancePct: -3.6, // negative = behind target
  weeklySqftCompleted: 18_240,
  weeklySqftTarget: 20_000,
  firstPassRatePct: 89.7,
  firstPassRateTarget: 92.0,
  dailyModulesCompletedPct: 84.5,
  dailyModulesCompletedTarget: 90.0,
};

// ─── Default goals (editable via Add/Edit Goals modal) ───────────────────────

export const DEFAULT_GOALS = {
  ytdCompletion: 90,
  onTimeDelivery: 95.0,
  weeklySqft: 20_000,
  firstPassRate: 92.0,
  dailyModulesCompleted: 90.0,
  milestones: [
    {
      id: 1,
      label: "Flatz 480 - Building 5, Foundation Complete",
      dueDate: "2026-03-31",
      done: true,
    },
    {
      id: 2,
      label: "Flatz 480 - Building 5, Framing Complete",
      dueDate: "2026-05-15",
      done: true,
    },
    {
      id: 3,
      label: "Flatz 480 - Building 6, First Module Delivery",
      dueDate: "2026-06-01",
      done: false,
    },
    {
      id: 4,
      label: "Flatz 326 - PROTO,  Production Start",
      dueDate: "2026-07-15",
      done: false,
    },
    {
      id: 5,
      label: "All Buildings — Final Inspection",
      dueDate: "2026-12-01",
      done: false,
    },
  ],
};

// ─── Completion Variance trend (last 8 weeks) ────────────────────────────────

export const COMPLETION_VARIANCE_TREND = [
  { week: "Wk 1", variance: 1.2 },
  { week: "Wk 2", variance: -0.8 },
  { week: "Wk 3", variance: 2.4 },
  { week: "Wk 4", variance: -1.1 },
  { week: "Wk 5", variance: -2.3 },
  { week: "Wk 6", variance: 0.7 },
  { week: "Wk 7", variance: -3.6 },
  { week: "Wk 8", variance: -1.9 },
];

export const VARIANCE_BY_MODULE = [
  {
    module: "12WO001234",
    scheduledDay: "Mar 10",
    actualDay: "Mar 10",
    varianceDays: 0,
  },
  {
    module: "12WO001235",
    scheduledDay: "Mar 12",
    actualDay: "Mar 13",
    varianceDays: 1,
  },
  {
    module: "12WO001236",
    scheduledDay: "Mar 14",
    actualDay: "Mar 12",
    varianceDays: -2,
  },
  {
    module: "12WO001240",
    scheduledDay: "Mar 17",
    actualDay: "Mar 20",
    varianceDays: 3,
  },
  {
    module: "12WO001241",
    scheduledDay: "Mar 18",
    actualDay: "Mar 19",
    varianceDays: 1,
  },
  {
    module: "12WO001243",
    scheduledDay: "Mar 19",
    actualDay: "Mar 22",
    varianceDays: 3,
  },
  {
    module: "12WO001391",
    scheduledDay: "Mar 21",
    actualDay: "Mar 21",
    varianceDays: 0,
  },
  {
    module: "12WO001392",
    scheduledDay: "Mar 24",
    actualDay: "Mar 28",
    varianceDays: 4,
  },
  {
    module: "12WO001393",
    scheduledDay: "Mar 26",
    actualDay: "Mar 25",
    varianceDays: -1,
  },
  {
    module: "12WO001394",
    scheduledDay: "Mar 28",
    actualDay: "Apr 02",
    varianceDays: 5,
  },
];

// ─── Weekly SQFT trend (last 8 weeks) ────────────────────────────────────────

export const WEEKLY_SQFT_HISTORY = [
  { week: "Wk 1", sqft: 19_400 },
  { week: "Wk 2", sqft: 20_850 },
  { week: "Wk 3", sqft: 17_920 },
  { week: "Wk 4", sqft: 21_100 },
  { week: "Wk 5", sqft: 19_680 },
  { week: "Wk 6", sqft: 22_300 },
  { week: "Wk 7", sqft: 18_050 },
  { week: "Wk 8", sqft: 18_240 },
];

export const SQFT_BY_BUILDING = [
  { building: "Flatz 480 - Building 5", sqft: 8_100, target: 8_500 },
  { building: "Flatz 480 - Building 6", sqft: 5_940, target: 6_500 },
  { building: "Flatz 325 - PROTO", sqft: 4_200, target: 5_000 },
];

// ─── First Pass Rate trend (last 9 months) ───────────────────────────────────

export const FIRST_PASS_RATE_TREND = [
  { month: "Jan", fpr: 87.2 },
  { month: "Feb", fpr: 88.0 },
  { month: "March", fpr: 90.4 },
  { month: "April", fpr: 91.1 },
  { month: "May", fpr: 89.8 },
  { month: "June", fpr: 88.5 },
  { month: "July", fpr: 90.2 },
  { month: "Aug", fpr: 91.6 },
  { month: "Sept", fpr: 95.0 },
  { month: "Oct", fpr: 92.7 },
  { month: "Nov", fpr: 88.7 },
  { month: "Dec", fpr: 89.7 },
];

export const FPR_BY_BUILDING = [
  { building: "Flatz 480 - Building 5", fpr: 91.4, target: 92.0 },
  { building: "Flatz 480 - Building 6", fpr: 88.9, target: 92.0 },
  { building: "Flatz 326 - PROTO", fpr: 87.2, target: 92.0 },
];

export const FPR_FAILURE_TYPES = [
  { type: "Fire Sprinkler Install", count: 14, pct: 31 },
  { type: "Plumbing Test", count: 11, pct: 24 },
  { type: "Electrical Test", count: 8, pct: 18 },
];

// ─── Daily Modules Completed (current month — April  2026) ────────────────────

export const DAILY_MODULES_HISTORY = [
  { date: "Apr 01", projected: 3, actual: 2, pct: 66.7 },
  { date: "Apr 02", projected: 3, actual: 4, pct: 133.4 },
  { date: "Apr 03", projected: 2, actual: 2, pct: 100.0 },
  { date: "Apr 06", projected: 3, actual: 2, pct: 66.7 },
  { date: "Apr 07", projected: 2, actual: 2, pct: 100.0 },
  { date: "Apr 08", projected: 2, actual: 2, pct: 100.0 },
  { date: "Apr 09", projected: 2, actual: 1, pct: 50.0 },
  { date: "Apr 10", projected: 3, actual: 2, pct: 66.7 },
  { date: "Apr 13", projected: 2, actual: 2, pct: 100.0 },
  { date: "Apr 14", projected: 2, actual: 1, pct: 50.0 },
  { date: "Apr 15", projected: 3, actual: 3, pct: 100.0 },
  { date: "Apr 16", projected: 2, actual: 2, pct: 100.0 },
  { date: "Apr 17", projected: 3, actual: 3, pct: 100.0 },
  { date: "Apr 20", projected: 3, actual: 4, pct: 133.4 },
  { date: "Apr 21", projected: 2, actual: 3, pct: 150.0 },
  { date: "Apr 22", projected: 3, actual: 2, pct: 66.7 },
  { date: "Apr 23", projected: 2, actual: 2, pct: 100.0 },
  { date: "Apr 24", projected: 2, actual: 3, pct: 133.4 },
  { date: "Apr 27", projected: 2, actual: 2, pct: 100.0 },
  { date: "Apr 28", projected: 3, actual: 1, pct: 33.4 },
  { date: "Apr 29", projected: 2, actual: 1, pct: 50.0 },
  { date: "Apr 30", projected: 2, actual: 2, pct: 50.0 },
];

// ─── Business weeks data ─────────────────────────────────────────────────────
// Each entry represents a business week.
// months: array of month indices (0-based) this week belongs to
//         (weeks spanning two months appear in both month lists).
// rollLeader: assigned roll leader for that week.
// days: Mon–Fri data (projectedRolls, actualRolls, projectedWraps, actualWraps).

export const WEEKS_DATA = {
  2025: {
    // January
    "2025-0-W1": {
      label: "Jan 6 – Jan 10",
      months: [0],
      spansBoundary: false,
      rollLeader: "Tim Caine",
      days: {
        Mon: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 3 },
        Tue: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 1 },
        Wed: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 4 },
        Thu: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 4 },
        Fri: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 2 },
      },
    },
    "2025-0-W2": {
      label: "Jan 13 – Jan 17",
      months: [0],
      spansBoundary: false,
      rollLeader: "Rowan Ripley",
      days: {
        Mon: { projRolls: 2, actRolls: 1, projWraps: 3, actWraps: 4 },
        Tue: { projRolls: 2, actRolls: 3, projWraps: 2, actWraps: 1 },
        Wed: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 1 },
        Thu: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 3 },
        Fri: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 2 },
      },
    },
    "2025-0-W3": {
      label: "Jan 20 – Jan 24",
      months: [0],
      spansBoundary: false,
      rollLeader: "Armond Littleton",
      days: {
        Mon: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 3 },
        Tue: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 1 },
        Wed: { projRolls: 3, actRolls: 2, projWraps: 2, actWraps: 2 },
        Thu: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 2 },
        Fri: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 3 },
      },
    },
    "2025-0-W4": {
      label: "Jan 27 – Jan 31",
      months: [0],
      spansBoundary: false,
      rollLeader: "Matthew Johnson",
      days: {
        Mon: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 2 },
        Tue: { projRolls: 3, actRolls: 2, projWraps: 3, actWraps: 3 },
        Wed: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 3 },
        Thu: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 1 },
        Fri: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 3 },
      },
    },
    // February
    "2025-1-W1": {
      label: "Feb 3 – Feb 7",
      months: [1],
      spansBoundary: false,
      rollLeader: "Brok Glazewski",
      days: {
        Mon: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 2 },
        Tue: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 2 },
        Wed: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 2 },
        Thu: { projRolls: 3, actRolls: 2, projWraps: 3, actWraps: 3 },
        Fri: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 3 },
      },
    },
    "2025-1-W2": {
      label: "Feb 10 – Feb 14",
      months: [1],
      spansBoundary: false,
      rollLeader: "Joseph Goritski",
      days: {
        Mon: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 2 },
        Tue: { projRolls: 3, actRolls: 4, projWraps: 3, actWraps: 3 },
        Wed: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 2 },
        Thu: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 3 },
        Fri: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 3 },
      },
    },
    "2025-1-W3": {
      label: "Feb 17 – Feb 21",
      months: [1],
      spansBoundary: false,
      rollLeader: "Francisco Zainos",
      days: {
        Mon: { projRolls: 2, actRolls: 1, projWraps: 3, actWraps: 3 },
        Tue: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 2 },
        Wed: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 2 },
        Thu: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 2 },
        Fri: { projRolls: 3, actRolls: 4, projWraps: 3, actWraps: 2 },
      },
    },
    "2025-1-W4": {
      label: "Feb 24 – Feb 28",
      months: [1],
      spansBoundary: false,
      rollLeader: "Myriah Gass",
      days: {
        Mon: { projRolls: 2, actRolls: 1, projWraps: 2, actWraps: 1 },
        Tue: { projRolls: 3, actRolls: 4, projWraps: 2, actWraps: 2 },
        Wed: { projRolls: 3, actRolls: 4, projWraps: 3, actWraps: 3 },
        Thu: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 3 },
        Fri: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 3 },
      },
    },
    // March
    "2025-2-W1": {
      label: "Mar 3 – Mar 7",
      months: [2],
      spansBoundary: false,
      rollLeader: "Michael Taylor",
      days: {
        Mon: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 2 },
        Tue: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 3 },
        Wed: { projRolls: 2, actRolls: 1, projWraps: 2, actWraps: 2 },
        Thu: { projRolls: 2, actRolls: 3, projWraps: 3, actWraps: 3 },
        Fri: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 2 },
      },
    },
    "2025-2-W2": {
      label: "Mar 10 – Mar 14",
      months: [2],
      spansBoundary: false,
      rollLeader: "Dominick Teller",
      days: {
        Mon: { projRolls: 2, actRolls: 3, projWraps: 2, actWraps: 2 },
        Tue: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 3 },
        Wed: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 1 },
        Thu: { projRolls: 3, actRolls: 2, projWraps: 3, actWraps: 2 },
        Fri: { projRolls: 2, actRolls: 3, projWraps: 3, actWraps: 2 },
      },
    },
    "2025-2-W3": {
      label: "Mar 17 – Mar 21",
      months: [2],
      spansBoundary: false,
      rollLeader: "Frederick Straun",
      days: {
        Mon: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 2 },
        Tue: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 2 },
        Wed: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 3 },
        Thu: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 3 },
        Fri: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 2 },
      },
    },
    "2025-2-W4": {
      label: "Mar 24 – Mar 28",
      months: [2],
      spansBoundary: false,
      rollLeader: "Andrew Volpetti",
      days: {
        Mon: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 3 },
        Tue: { projRolls: 2, actRolls: 1, projWraps: 3, actWraps: 3 },
        Wed: { projRolls: 3, actRolls: 4, projWraps: 2, actWraps: 1 },
        Thu: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 3 },
        Fri: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 3 },
      },
    },
    "2025-2-W5": {
      label: "Mar 31 – Apr 4",
      months: [2, 3],
      spansBoundary: true,
      spanLabel: "Mar 31 – Apr 4",
      rollLeader: "Christian Garay",
      days: {
        Mon: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 4 },
        Tue: { projRolls: 3, actRolls: 4, projWraps: 2, actWraps: 2 },
        Wed: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 3 },
        Thu: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 3 },
        Fri: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 2 },
      },
    },
    // April
    "2025-3-W1": {
      label: "Apr 7 – Apr 11",
      months: [3],
      spansBoundary: false,
      rollLeader: "Robert Bauder",
      days: {
        Mon: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 3 },
        Tue: { projRolls: 3, actRolls: 2, projWraps: 2, actWraps: 2 },
        Wed: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 1 },
        Thu: { projRolls: 3, actRolls: 4, projWraps: 3, actWraps: 2 },
        Fri: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 1 },
      },
    },
    "2025-3-W2": {
      label: "Apr 14 – Apr 18",
      months: [3],
      spansBoundary: false,
      rollLeader: "Jose Casillas",
      days: {
        Mon: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 2 },
        Tue: { projRolls: 3, actRolls: 4, projWraps: 3, actWraps: 3 },
        Wed: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 1 },
        Thu: { projRolls: 3, actRolls: 2, projWraps: 2, actWraps: 2 },
        Fri: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 3 },
      },
    },
    "2025-3-W3": {
      label: "Apr 21 – Apr 25",
      months: [3],
      spansBoundary: false,
      rollLeader: "Tim Caine",
      days: {
        Mon: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 3 },
        Tue: { projRolls: 2, actRolls: 3, projWraps: 2, actWraps: 2 },
        Wed: { projRolls: 2, actRolls: 3, projWraps: 3, actWraps: 3 },
        Thu: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 1 },
        Fri: { projRolls: 3, actRolls: 4, projWraps: 2, actWraps: 3 },
      },
    },
    // Apr 28 – May 2 spans April/May boundary
    "2025-3-W4": {
      label: "Apr 28 – May 2",
      months: [3, 4],
      spansBoundary: true,
      spanLabel: "Apr 28 – May 2",
      rollLeader: "Rowan Ripley",
      days: {
        Mon: { projRolls: 3, actRolls: 2, projWraps: 2, actWraps: 1 },
        Tue: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 2 },
        Wed: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 4 },
        Thu: { projRolls: 2, actRolls: 3, projWraps: 2, actWraps: 2 },
        Fri: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 3 },
      },
    },
    // May
    "2025-4-W1": {
      label: "May 5 – May 9",
      months: [4],
      spansBoundary: false,
      rollLeader: "Armond Littleton",
      days: {
        Mon: { projRolls: 3, actRolls: 4, projWraps: 2, actWraps: 3 },
        Tue: { projRolls: 3, actRolls: 2, projWraps: 3, actWraps: 3 },
        Wed: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 3 },
        Thu: { projRolls: 2, actRolls: 3, projWraps: 3, actWraps: 4 },
        Fri: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 4 },
      },
    },
    "2025-4-W2": {
      label: "May 12 – May 16",
      months: [4],
      spansBoundary: false,
      rollLeader: "Matthew Johnson",
      days: {
        Mon: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 2 },
        Tue: { projRolls: 2, actRolls: 3, projWraps: 3, actWraps: 3 },
        Wed: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 4 },
        Thu: { projRolls: 3, actRolls: 2, projWraps: 3, actWraps: 3 },
        Fri: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 3 },
      },
    },
    "2025-4-W3": {
      label: "May 19 – May 23",
      months: [4],
      spansBoundary: false,
      rollLeader: "Brok Glazewski",
      days: {
        Mon: { projRolls: 2, actRolls: 1, projWraps: 2, actWraps: 1 },
        Tue: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 1 },
        Wed: { projRolls: 2, actRolls: 3, projWraps: 2, actWraps: 2 },
        Thu: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 2 },
        Fri: { projRolls: 3, actRolls: 2, projWraps: 2, actWraps: 1 },
      },
    },
    "2025-4-W4": {
      label: "May 26 – May 30",
      months: [4],
      spansBoundary: false,
      rollLeader: "Joseph Goritski",
      days: {
        Mon: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 1 },
        Tue: { projRolls: 3, actRolls: 4, projWraps: 2, actWraps: 2 },
        Wed: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 3 },
        Thu: { projRolls: 3, actRolls: 4, projWraps: 2, actWraps: 2 },
        Fri: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 2 },
      },
    },
    // June
    "2025-5-W1": {
      label: "Jun 2 – Jun 6",
      months: [5],
      spansBoundary: false,
      rollLeader: "Francisco Zainos",
      days: {
        Mon: { projRolls: 2, actRolls: 3, projWraps: 2, actWraps: 2 },
        Tue: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 2 },
        Wed: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 3 },
        Thu: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 3 },
        Fri: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 3 },
      },
    },
    "2025-5-W2": {
      label: "Jun 9 – Jun 13",
      months: [5],
      spansBoundary: false,
      rollLeader: "Myriah Gass",
      days: {
        Mon: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 3 },
        Tue: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 2 },
        Wed: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 3 },
        Thu: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 3 },
        Fri: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 1 },
      },
    },
    "2025-5-W3": {
      label: "Jun 16 – Jun 20",
      months: [5],
      spansBoundary: false,
      rollLeader: "Michael Taylor",
      days: {
        Mon: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 2 },
        Tue: { projRolls: 3, actRolls: 4, projWraps: 3, actWraps: 2 },
        Wed: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 2 },
        Thu: { projRolls: 2, actRolls: 3, projWraps: 2, actWraps: 2 },
        Fri: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 2 },
      },
    },
    "2025-5-W4": {
      label: "Jun 23 – Jun 27",
      months: [5],
      spansBoundary: false,
      rollLeader: "Dominick Teller",
      days: {
        Mon: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 2 },
        Tue: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 3 },
        Wed: { projRolls: 3, actRolls: 4, projWraps: 2, actWraps: 2 },
        Thu: { projRolls: 3, actRolls: 4, projWraps: 2, actWraps: 3 },
        Fri: { projRolls: 3, actRolls: 4, projWraps: 2, actWraps: 2 },
      },
    },
    // Jun 30 – Jul 4 spans June/July boundary
    "2025-5-W5": {
      label: "Jun 30 – Jul 4",
      months: [5, 6],
      spansBoundary: true,
      spanLabel: "Jun 30 – Jul 4",
      rollLeader: "Frederick Straun",
      days: {
        Mon: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 3 },
        Tue: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 2 },
        Wed: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 3 },
        Thu: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 2 },
        Fri: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 2 },
      },
    },
    // July
    "2025-6-W1": {
      label: "Jul 7 – Jul 11",
      months: [6],
      spansBoundary: false,
      rollLeader: "Andrew Volpetti",
      days: {
        Mon: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 1 },
        Tue: { projRolls: 2, actRolls: 1, projWraps: 3, actWraps: 3 },
        Wed: { projRolls: 2, actRolls: 1, projWraps: 3, actWraps: 2 },
        Thu: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 4 },
        Fri: { projRolls: 2, actRolls: 1, projWraps: 2, actWraps: 2 },
      },
    },
    "2025-6-W2": {
      label: "Jul 14 – Jul 18",
      months: [6],
      spansBoundary: false,
      rollLeader: "Christian Garay",
      days: {
        Mon: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 2 },
        Tue: { projRolls: 2, actRolls: 1, projWraps: 3, actWraps: 3 },
        Wed: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 3 },
        Thu: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 3 },
        Fri: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 2 },
      },
    },
    "2025-6-W3": {
      label: "Jul 21 – Jul 25",
      months: [6],
      spansBoundary: false,
      rollLeader: "Robert Bauder",
      days: {
        Mon: { projRolls: 2, actRolls: 3, projWraps: 3, actWraps: 4 },
        Tue: { projRolls: 3, actRolls: 2, projWraps: 3, actWraps: 4 },
        Wed: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 3 },
        Thu: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 3 },
        Fri: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 1 },
      },
    },
    // Jul 28 – Aug 1 spans July/August boundary
    "2025-6-W4": {
      label: "Jul 28 – Aug 1",
      months: [6, 7],
      spansBoundary: true,
      spanLabel: "Jul 28 – Aug 1",
      rollLeader: "Jose Casillas",
      days: {
        Mon: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 2 },
        Tue: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 3 },
        Wed: { projRolls: 3, actRolls: 4, projWraps: 3, actWraps: 3 },
        Thu: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 2 },
        Fri: { projRolls: 2, actRolls: 3, projWraps: 2, actWraps: 2 },
      },
    },
    // August
    "2025-7-W1": {
      label: "Aug 4 – Aug 8",
      months: [7],
      spansBoundary: false,
      rollLeader: "Tim Caine",
      days: {
        Mon: { projRolls: 3, actRolls: 4, projWraps: 2, actWraps: 3 },
        Tue: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 1 },
        Wed: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 3 },
        Thu: { projRolls: 3, actRolls: 4, projWraps: 3, actWraps: 4 },
        Fri: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 2 },
      },
    },
    "2025-7-W2": {
      label: "Aug 11 – Aug 15",
      months: [7],
      spansBoundary: false,
      rollLeader: "Rowan Ripley",
      days: {
        Mon: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 3 },
        Tue: { projRolls: 2, actRolls: 1, projWraps: 2, actWraps: 3 },
        Wed: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 1 },
        Thu: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 2 },
        Fri: { projRolls: 3, actRolls: 4, projWraps: 3, actWraps: 4 },
      },
    },
    "2025-7-W3": {
      label: "Aug 18 – Aug 22",
      months: [7],
      spansBoundary: false,
      rollLeader: "Armond Littleton",
      days: {
        Mon: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 1 },
        Tue: { projRolls: 2, actRolls: 3, projWraps: 3, actWraps: 3 },
        Wed: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 2 },
        Thu: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 2 },
        Fri: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 2 },
      },
    },
    "2025-7-W4": {
      label: "Aug 25 – Aug 29",
      months: [7],
      spansBoundary: false,
      rollLeader: "Matthew Johnson",
      days: {
        Mon: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 2 },
        Tue: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 4 },
        Wed: { projRolls: 2, actRolls: 1, projWraps: 3, actWraps: 3 },
        Thu: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 3 },
        Fri: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 3 },
      },
    },
    // September
    "2025-8-W1": {
      label: "Sep 1 – Sep 5",
      months: [8],
      spansBoundary: false,
      rollLeader: "Brok Glazewski",
      days: {
        Mon: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 2 },
        Tue: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 1 },
        Wed: { projRolls: 3, actRolls: 2, projWraps: 2, actWraps: 3 },
        Thu: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 3 },
        Fri: { projRolls: 3, actRolls: 4, projWraps: 3, actWraps: 3 },
      },
    },
    "2025-8-W2": {
      label: "Sep 8 – Sep 12",
      months: [8],
      spansBoundary: false,
      rollLeader: "Joseph Goritski",
      days: {
        Mon: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 2 },
        Tue: { projRolls: 2, actRolls: 1, projWraps: 3, actWraps: 3 },
        Wed: { projRolls: 2, actRolls: 3, projWraps: 2, actWraps: 2 },
        Thu: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 4 },
        Fri: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 1 },
      },
    },
    "2025-8-W3": {
      label: "Sep 15 – Sep 19",
      months: [8],
      spansBoundary: false,
      rollLeader: "Francisco Zainos",
      days: {
        Mon: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 1 },
        Tue: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 2 },
        Wed: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 2 },
        Thu: { projRolls: 2, actRolls: 1, projWraps: 3, actWraps: 3 },
        Fri: { projRolls: 3, actRolls: 4, projWraps: 2, actWraps: 2 },
      },
    },
    "2025-8-W4": {
      label: "Sep 22 – Sep 26",
      months: [8],
      spansBoundary: false,
      rollLeader: "Myriah Gass",
      days: {
        Mon: { projRolls: 2, actRolls: 3, projWraps: 2, actWraps: 1 },
        Tue: { projRolls: 3, actRolls: 2, projWraps: 2, actWraps: 1 },
        Wed: { projRolls: 2, actRolls: 1, projWraps: 2, actWraps: 3 },
        Thu: { projRolls: 3, actRolls: 2, projWraps: 3, actWraps: 3 },
        Fri: { projRolls: 3, actRolls: 4, projWraps: 2, actWraps: 3 },
      },
    },
    // Sep 29 – Oct 3 spans September/October boundary
    "2025-8-W5": {
      label: "Sep 29 – Oct 3",
      months: [8, 9],
      spansBoundary: true,
      spanLabel: "Sep 29 – Oct 3",
      rollLeader: "Michael Taylor",
      days: {
        Mon: { projRolls: 3, actRolls: 4, projWraps: 3, actWraps: 4 },
        Tue: { projRolls: 2, actRolls: 3, projWraps: 2, actWraps: 2 },
        Wed: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 2 },
        Thu: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 1 },
        Fri: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 2 },
      },
    },
    // October
    "2025-9-W1": {
      label: "Oct 6 – Oct 10",
      months: [9],
      spansBoundary: false,
      rollLeader: "Dominick Teller",
      days: {
        Mon: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 2 },
        Tue: { projRolls: 2, actRolls: 3, projWraps: 3, actWraps: 2 },
        Wed: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 3 },
        Thu: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 1 },
        Fri: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 3 },
      },
    },
    "2025-9-W2": {
      label: "Oct 13 – Oct 17",
      months: [9],
      spansBoundary: false,
      rollLeader: "Frederick Straun",
      days: {
        Mon: { projRolls: 3, actRolls: 2, projWraps: 3, actWraps: 3 },
        Tue: { projRolls: 2, actRolls: 3, projWraps: 2, actWraps: 3 },
        Wed: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 3 },
        Thu: { projRolls: 3, actRolls: 4, projWraps: 3, actWraps: 3 },
        Fri: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 3 },
      },
    },
    "2025-9-W3": {
      label: "Oct 20 – Oct 24",
      months: [9],
      spansBoundary: false,
      rollLeader: "Andrew Volpetti",
      days: {
        Mon: { projRolls: 2, actRolls: 3, projWraps: 2, actWraps: 3 },
        Tue: { projRolls: 2, actRolls: 1, projWraps: 3, actWraps: 3 },
        Wed: { projRolls: 3, actRolls: 2, projWraps: 2, actWraps: 3 },
        Thu: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 3 },
        Fri: { projRolls: 2, actRolls: 1, projWraps: 3, actWraps: 2 },
      },
    },
    "2025-9-W4": {
      label: "Oct 27 – Oct 31",
      months: [9],
      spansBoundary: false,
      rollLeader: "Christian Garay",
      days: {
        Mon: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 2 },
        Tue: { projRolls: 2, actRolls: 1, projWraps: 2, actWraps: 3 },
        Wed: { projRolls: 3, actRolls: 2, projWraps: 3, actWraps: 3 },
        Thu: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 3 },
        Fri: { projRolls: 2, actRolls: 3, projWraps: 3, actWraps: 4 },
      },
    },
    // November
    "2025-10-W1": {
      label: "Nov 3 – Nov 7",
      months: [10],
      spansBoundary: false,
      rollLeader: "Robert Bauder",
      days: {
        Mon: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 2 },
        Tue: { projRolls: 3, actRolls: 4, projWraps: 3, actWraps: 2 },
        Wed: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 1 },
        Thu: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 2 },
        Fri: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 3 },
      },
    },
    "2025-10-W2": {
      label: "Nov 10 – Nov 14",
      months: [10],
      spansBoundary: false,
      rollLeader: "Jose Casillas",
      days: {
        Mon: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 3 },
        Tue: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 3 },
        Wed: { projRolls: 2, actRolls: 3, projWraps: 2, actWraps: 1 },
        Thu: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 3 },
        Fri: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 2 },
      },
    },
    "2025-10-W3": {
      label: "Nov 17 – Nov 21",
      months: [10],
      spansBoundary: false,
      rollLeader: "Tim Caine",
      days: {
        Mon: { projRolls: 2, actRolls: 1, projWraps: 2, actWraps: 3 },
        Tue: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 2 },
        Wed: { projRolls: 3, actRolls: 4, projWraps: 3, actWraps: 3 },
        Thu: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 2 },
        Fri: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 3 },
      },
    },
    "2025-10-W4": {
      label: "Nov 24 – Nov 28",
      months: [10],
      spansBoundary: false,
      rollLeader: "Rowan Ripley",
      days: {
        Mon: { projRolls: 3, actRolls: 2, projWraps: 2, actWraps: 2 },
        Tue: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 1 },
        Wed: { projRolls: 3, actRolls: 4, projWraps: 3, actWraps: 3 },
        Thu: { projRolls: 2, actRolls: 1, projWraps: 2, actWraps: 3 },
        Fri: { projRolls: 3, actRolls: 2, projWraps: 2, actWraps: 3 },
      },
    },
    // December
    "2025-11-W1": {
      label: "Dec 1 – Dec 5",
      months: [11],
      spansBoundary: false,
      rollLeader: "Armond Littleton",
      days: {
        Mon: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 2 },
        Tue: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 3 },
        Wed: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 2 },
        Thu: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 3 },
        Fri: { projRolls: 3, actRolls: 3, projWraps: 2, actWraps: 2 },
      },
    },
    "2025-11-W2": {
      label: "Dec 8 – Dec 12",
      months: [11],
      spansBoundary: false,
      rollLeader: "Matthew Johnson",
      days: {
        Mon: { projRolls: 2, actRolls: 2, projWraps: 3, actWraps: 2 },
        Tue: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 2 },
        Wed: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 3 },
        Thu: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 1 },
        Fri: { projRolls: 2, actRolls: 1, projWraps: 2, actWraps: 2 },
      },
    },
    "2025-11-W3": {
      label: "Dec 15 – Dec 19",
      months: [11],
      spansBoundary: false,
      rollLeader: "Brok Glazewski",
      days: {
        Mon: { projRolls: 2, actRolls: 1, projWraps: 3, actWraps: 4 },
        Tue: { projRolls: 3, actRolls: 4, projWraps: 3, actWraps: 3 },
        Wed: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 3 },
        Thu: { projRolls: 2, actRolls: 3, projWraps: 3, actWraps: 3 },
        Fri: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 2 },
      },
    },
    "2025-11-W4": {
      label: "Dec 22 – Dec 26",
      months: [11],
      spansBoundary: false,
      rollLeader: "Joseph Goritski",
      days: {
        Mon: { projRolls: 3, actRolls: 3, projWraps: 3, actWraps: 3 },
        Tue: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 1 },
        Wed: { projRolls: 2, actRolls: 1, projWraps: 2, actWraps: 2 },
        Thu: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 1 },
        Fri: { projRolls: 2, actRolls: 2, projWraps: 2, actWraps: 3 },
      },
    },
  },
  2026: {
    // January
    "2026-0-W1": {
      label: "Jan 06 – Jan 10",
      months: [0],
      spansBoundary: false,
      rollLeader: "Matthew Johnson",
      days: {
        Mon: { projRolls: 6, actRolls: 6, projWraps: 2, actWraps: 2 },
        Tue: { projRolls: 6, actRolls: 7, projWraps: 2, actWraps: 3 },
        Wed: { projRolls: 6, actRolls: 5, projWraps: 2, actWraps: 2 },
        Thu: { projRolls: 6, actRolls: 6, projWraps: 2, actWraps: 2 },
        Fri: { projRolls: 6, actRolls: 6, projWraps: 3, actWraps: 2 },
      },
    },
    "2026-0-W2": {
      label: "Jan 13 – Jan 17",
      months: [0],
      spansBoundary: false,
      rollLeader: "Jose Casillas",
      days: {
        Mon: { projRolls: 6, actRolls: 5, projWraps: 2, actWraps: 1 },
        Tue: { projRolls: 6, actRolls: 6, projWraps: 2, actWraps: 2 },
        Wed: { projRolls: 6, actRolls: 7, projWraps: 2, actWraps: 3 },
        Thu: { projRolls: 6, actRolls: 6, projWraps: 2, actWraps: 2 },
        Fri: { projRolls: 6, actRolls: 6, projWraps: 2, actWraps: 2 },
      },
    },
    "2026-0-W3": {
      label: "Jan 20 – Jan 24",
      months: [0],
      spansBoundary: false,
      rollLeader: "Myriah Gass",
      days: {
        Mon: { projRolls: 6, actRolls: 6, projWraps: 2, actWraps: 2 },
        Tue: { projRolls: 6, actRolls: 6, projWraps: 2, actWraps: 2 },
        Wed: { projRolls: 6, actRolls: 4, projWraps: 2, actWraps: 1 },
        Thu: { projRolls: 6, actRolls: 7, projWraps: 2, actWraps: 3 },
        Fri: { projRolls: 6, actRolls: 6, projWraps: 3, actWraps: 3 },
      },
    },
    // Jan 27 – Jan 31 (spans Jan/Feb boundary: Mon–Thu Jan, Fri Feb 1 is weekend, so stays in Jan)
    "2026-0-W4": {
      label: "Jan 27 – Jan 31",
      months: [0],
      spansBoundary: false,
      rollLeader: "Matthew Johnson",
      days: {
        Mon: { projRolls: 6, actRolls: 6, projWraps: 2, actWraps: 2 },
        Tue: { projRolls: 6, actRolls: 6, projWraps: 2, actWraps: 2 },
        Wed: { projRolls: 6, actRolls: 6, projWraps: 2, actWraps: 2 },
        Thu: { projRolls: 6, actRolls: 5, projWraps: 2, actWraps: 1 },
        Fri: { projRolls: 6, actRolls: 7, projWraps: 2, actWraps: 3 },
      },
    },
    // February
    "2026-1-W1": {
      label: "Feb 03 – Feb 07",
      months: [1],
      spansBoundary: false,
      rollLeader: "Jose Casillas",
      days: {
        Mon: { projRolls: 7, actRolls: 7, projWraps: 3, actWraps: 3 },
        Tue: { projRolls: 7, actRolls: 6, projWraps: 3, actWraps: 2 },
        Wed: { projRolls: 7, actRolls: 8, projWraps: 3, actWraps: 4 },
        Thu: { projRolls: 7, actRolls: 7, projWraps: 3, actWraps: 3 },
        Fri: { projRolls: 7, actRolls: 7, projWraps: 3, actWraps: 3 },
      },
    },
    "2026-1-W2": {
      label: "Feb 10 – Feb 14",
      months: [1],
      spansBoundary: false,
      rollLeader: "Myriah Gass",
      days: {
        Mon: { projRolls: 7, actRolls: 7, projWraps: 3, actWraps: 3 },
        Tue: { projRolls: 7, actRolls: 7, projWraps: 3, actWraps: 3 },
        Wed: { projRolls: 7, actRolls: 6, projWraps: 3, actWraps: 2 },
        Thu: { projRolls: 7, actRolls: 8, projWraps: 3, actWraps: 4 },
        Fri: { projRolls: 7, actRolls: 7, projWraps: 3, actWraps: 3 },
      },
    },
    "2026-1-W3": {
      label: "Feb 17 – Feb 21",
      months: [1],
      spansBoundary: false,
      rollLeader: "Matthew Johnson",
      days: {
        Mon: { projRolls: 7, actRolls: 5, projWraps: 3, actWraps: 2 },
        Tue: { projRolls: 7, actRolls: 7, projWraps: 3, actWraps: 3 },
        Wed: { projRolls: 7, actRolls: 8, projWraps: 3, actWraps: 4 },
        Thu: { projRolls: 7, actRolls: 7, projWraps: 3, actWraps: 3 },
        Fri: { projRolls: 7, actRolls: 7, projWraps: 3, actWraps: 3 },
      },
    },
    // Feb 24 – Feb 28 (Fri = Feb 28, Mon = Mar 3 is next week, so stays in Feb)
    "2026-1-W4": {
      label: "Feb 24 – Feb 28",
      months: [1],
      spansBoundary: false,
      rollLeader: "Jose Casillas",
      days: {
        Mon: { projRolls: 7, actRolls: 7, projWraps: 3, actWraps: 3 },
        Tue: { projRolls: 7, actRolls: 6, projWraps: 3, actWraps: 2 },
        Wed: { projRolls: 7, actRolls: 7, projWraps: 3, actWraps: 3 },
        Thu: { projRolls: 7, actRolls: 8, projWraps: 3, actWraps: 4 },
        Fri: { projRolls: 7, actRolls: 7, projWraps: 3, actWraps: 3 },
      },
    },
    // March
    "2026-2-W1": {
      label: "Mar 03 – Mar 07",
      months: [2],
      spansBoundary: false,
      rollLeader: "Myriah Gass",
      days: {
        Mon: { projRolls: 8, actRolls: 8, projWraps: 3, actWraps: 3 },
        Tue: { projRolls: 8, actRolls: 9, projWraps: 3, actWraps: 4 },
        Wed: { projRolls: 8, actRolls: 8, projWraps: 3, actWraps: 3 },
        Thu: { projRolls: 8, actRolls: 7, projWraps: 3, actWraps: 2 },
        Fri: { projRolls: 8, actRolls: 8, projWraps: 3, actWraps: 3 },
      },
    },
    "2026-2-W2": {
      label: "Mar 10 – Mar 14",
      months: [2],
      spansBoundary: false,
      rollLeader: "Matthew Johnson",
      days: {
        Mon: { projRolls: 8, actRolls: 8, projWraps: 3, actWraps: 3 },
        Tue: { projRolls: 8, actRolls: 8, projWraps: 3, actWraps: 3 },
        Wed: { projRolls: 8, actRolls: 10, projWraps: 3, actWraps: 5 },
        Thu: { projRolls: 8, actRolls: 8, projWraps: 3, actWraps: 3 },
        Fri: { projRolls: 8, actRolls: 7, projWraps: 3, actWraps: 2 },
      },
    },
    "2026-2-W3": {
      label: "Mar 17 – Mar 21",
      months: [2],
      spansBoundary: false,
      rollLeader: "Jose Casillas",
      days: {
        Mon: { projRolls: 8, actRolls: 8, projWraps: 4, actWraps: 4 },
        Tue: { projRolls: 8, actRolls: 8, projWraps: 4, actWraps: 4 },
        Wed: { projRolls: 8, actRolls: 9, projWraps: 4, actWraps: 5 },
        Thu: { projRolls: 8, actRolls: 8, projWraps: 4, actWraps: 4 },
        Fri: { projRolls: 8, actRolls: 7, projWraps: 4, actWraps: 3 },
      },
    },
    "2026-2-W4": {
      label: "Mar 24 – Mar 28",
      months: [2],
      spansBoundary: false,
      rollLeader: "Myriah Gass",
      days: {
        Mon: { projRolls: 8, actRolls: 8, projWraps: 4, actWraps: 4 },
        Tue: { projRolls: 8, actRolls: 9, projWraps: 4, actWraps: 4 },
        Wed: { projRolls: 8, actRolls: 8, projWraps: 4, actWraps: 3 },
        Thu: { projRolls: 8, actRolls: 8, projWraps: 4, actWraps: 4 },
        Fri: { projRolls: 8, actRolls: 6, projWraps: 4, actWraps: 2 },
      },
    },
    // Mar 31 – Apr 04 spans March/April boundary
    "2026-2-W5": {
      label: "Mar 31 – Apr 04",
      months: [2, 3], // appears in both March and April
      spansBoundary: true,
      spanLabel: "Mar 31 – Apr 04",
      rollLeader: "Matthew Johnson",
      days: {
        Mon: { projRolls: 8, actRolls: 8, projWraps: 4, actWraps: 4 },
        Tue: { projRolls: 8, actRolls: 7, projWraps: 4, actWraps: 3 },
        Wed: { projRolls: 8, actRolls: 8, projWraps: 4, actWraps: 4 },
        Thu: { projRolls: 8, actRolls: 9, projWraps: 4, actWraps: 5 },
        Fri: { projRolls: 8, actRolls: 8, projWraps: 4, actWraps: 4 },
      },
    },
    // April
    "2026-3-W1": {
      label: "Apr 07 – Apr 11",
      months: [3],
      spansBoundary: false,
      rollLeader: "Jose Casillas",
      days: {
        Mon: { projRolls: 9, actRolls: 9, projWraps: 4, actWraps: 4 },
        Tue: { projRolls: 9, actRolls: 10, projWraps: 4, actWraps: 5 },
        Wed: { projRolls: 9, actRolls: 9, projWraps: 4, actWraps: 4 },
        Thu: { projRolls: 9, actRolls: 8, projWraps: 4, actWraps: 3 },
        Fri: { projRolls: 9, actRolls: 9, projWraps: 4, actWraps: 4 },
      },
    },
    "2026-3-W2": {
      label: "Apr 14 – Apr 18",
      months: [3],
      spansBoundary: false,
      rollLeader: "Myriah Gass",
      days: {
        Mon: { projRolls: 9, actRolls: 9, projWraps: 4, actWraps: 4 },
        Tue: { projRolls: 9, actRolls: 9, projWraps: 4, actWraps: 4 },
        Wed: { projRolls: 9, actRolls: 11, projWraps: 4, actWraps: 6 },
        Thu: { projRolls: 9, actRolls: 9, projWraps: 4, actWraps: 4 },
        Fri: { projRolls: 9, actRolls: 8, projWraps: 4, actWraps: 3 },
      },
    },
    "2026-3-W3": {
      label: "Apr 21 – Apr 25",
      months: [3],
      spansBoundary: false,
      rollLeader: "Matthew Johnson",
      days: {
        Mon: { projRolls: 9, actRolls: 9, projWraps: 5, actWraps: 5 },
        Tue: { projRolls: 9, actRolls: 9, projWraps: 5, actWraps: 5 },
        Wed: { projRolls: 9, actRolls: 8, projWraps: 5, actWraps: 4 },
        Thu: { projRolls: 9, actRolls: 9, projWraps: 5, actWraps: 5 },
        Fri: { projRolls: 9, actRolls: 10, projWraps: 5, actWraps: 6 },
      },
    },
    // Apr 28 – May 02 spans April/May boundary
    "2026-3-W4": {
      label: "Apr 28 – May 02",
      months: [3, 4],
      spansBoundary: true,
      spanLabel: "Apr 28 – May 02",
      rollLeader: "Jose Casillas",
      days: {
        Mon: { projRolls: 9, actRolls: 9, projWraps: 5, actWraps: 5 },
        Tue: { projRolls: 9, actRolls: 9, projWraps: 5, actWraps: 5 },
        Wed: { projRolls: 9, actRolls: 10, projWraps: 5, actWraps: 6 },
        Thu: { projRolls: 9, actRolls: 9, projWraps: 5, actWraps: 5 },
        Fri: { projRolls: 9, actRolls: 8, projWraps: 5, actWraps: 4 },
      },
    },
    // May
    "2026-4-W1": {
      label: "May 05 – May 09",
      months: [4],
      spansBoundary: false,
      rollLeader: "Myriah Gass",
      days: {
        Mon: { projRolls: 9, actRolls: 9, projWraps: 5, actWraps: 5 },
        Tue: { projRolls: 9, actRolls: 10, projWraps: 5, actWraps: 5 },
        Wed: { projRolls: 9, actRolls: 9, projWraps: 5, actWraps: 5 },
        Thu: { projRolls: 9, actRolls: 9, projWraps: 5, actWraps: 5 },
        Fri: { projRolls: 9, actRolls: 8, projWraps: 5, actWraps: 4 },
      },
    },
    "2026-4-W2": {
      label: "May 12 – May 16",
      months: [4],
      spansBoundary: false,
      rollLeader: "Matthew Johnson",
      days: {
        Mon: { projRolls: 9, actRolls: 9, projWraps: 5, actWraps: 5 },
        Tue: { projRolls: 9, actRolls: 9, projWraps: 5, actWraps: 5 },
        Wed: { projRolls: 9, actRolls: 9, projWraps: 5, actWraps: 5 },
        Thu: { projRolls: 9, actRolls: 10, projWraps: 5, actWraps: 6 },
        Fri: { projRolls: 9, actRolls: 9, projWraps: 5, actWraps: 5 },
      },
    },
    "2026-4-W3": {
      label: "May 19 – May 23",
      months: [4],
      spansBoundary: false,
      rollLeader: "Jose Casillas",
      days: {
        Mon: { projRolls: 9, actRolls: 8, projWraps: 5, actWraps: 4 },
        Tue: { projRolls: 9, actRolls: 9, projWraps: 5, actWraps: 5 },
        Wed: { projRolls: 9, actRolls: 9, projWraps: 5, actWraps: 5 },
        Thu: { projRolls: 9, actRolls: 9, projWraps: 5, actWraps: 5 },
        Fri: { projRolls: 9, actRolls: 10, projWraps: 5, actWraps: 6 },
      },
    },
    // May 26 – May 30
    "2026-4-W4": {
      label: "May 26 – May 30",
      months: [4],
      spansBoundary: false,
      rollLeader: "Myriah Gass",
      days: {
        Mon: { projRolls: 9, actRolls: 9, projWraps: 5, actWraps: 5 },
        Tue: { projRolls: 9, actRolls: 9, projWraps: 5, actWraps: 5 },
        Wed: { projRolls: 9, actRolls: 8, projWraps: 5, actWraps: 4 },
        Thu: { projRolls: 9, actRolls: 9, projWraps: 5, actWraps: 5 },
        Fri: { projRolls: 9, actRolls: 9, projWraps: 5, actWraps: 5 },
      },
    },
  },
};

// ─── Monthly Production Trend ─────────────────────────────────────────────────
// Keyed as "YYYY-M" (0-based month). Each entry = array of daily data points.

export const MONTHLY_TREND = {
  "2025-0": [
    { day: 2, sqft: 1391, personnel: 145 },
    { day: 3, sqft: 1334, personnel: 144 },
    { day: 6, sqft: 1218, personnel: 143 },
    { day: 7, sqft: 977, personnel: 142 },
    { day: 8, sqft: 1422, personnel: 144 },
    { day: 9, sqft: 1064, personnel: 142 },
    { day: 10, sqft: 1106, personnel: 159 },
    { day: 13, sqft: 997, personnel: 166 },
    { day: 14, sqft: 1465, personnel: 168 },
    { day: 15, sqft: 613, personnel: 148 },
    { day: 16, sqft: 1178, personnel: 157 },
    { day: 17, sqft: 1548, personnel: 141 },
    { day: 20, sqft: 1019, personnel: 165 },
    { day: 21, sqft: 1209, personnel: 167 },
    { day: 22, sqft: 1543, personnel: 152 },
    { day: 23, sqft: 1149, personnel: 161 },
    { day: 24, sqft: 919, personnel: 159 },
    { day: 27, sqft: 1220, personnel: 160 },
    { day: 28, sqft: 1045, personnel: 153 },
    { day: 29, sqft: 1226, personnel: 165 },
    { day: 30, sqft: 632, personnel: 141 },
    { day: 31, sqft: 1227, personnel: 163 },
  ],
  "2025-1": [
    { day: 3, sqft: 811, personnel: 168 },
    { day: 4, sqft: 1397, personnel: 161 },
    { day: 5, sqft: 1448, personnel: 154 },
    { day: 6, sqft: 1058, personnel: 164 },
    { day: 7, sqft: 1566, personnel: 150 },
    { day: 10, sqft: 869, personnel: 157 },
    { day: 11, sqft: 1466, personnel: 143 },
    { day: 12, sqft: 1410, personnel: 158 },
    { day: 13, sqft: 1308, personnel: 147 },
    { day: 14, sqft: 1325, personnel: 155 },
    { day: 17, sqft: 789, personnel: 158 },
    { day: 18, sqft: 786, personnel: 164 },
    { day: 19, sqft: 850, personnel: 159 },
    { day: 20, sqft: 1484, personnel: 147 },
    { day: 21, sqft: 972, personnel: 153 },
    { day: 24, sqft: 1374, personnel: 166 },
    { day: 25, sqft: 1366, personnel: 145 },
    { day: 26, sqft: 1558, personnel: 158 },
    { day: 27, sqft: 1404, personnel: 148 },
    { day: 28, sqft: 1117, personnel: 147 },
  ],
  "2025-2": [
    { day: 3, sqft: 1054, personnel: 165 },
    { day: 4, sqft: 684, personnel: 160 },
    { day: 5, sqft: 853, personnel: 154 },
    { day: 6, sqft: 1456, personnel: 161 },
    { day: 7, sqft: 665, personnel: 165 },
    { day: 10, sqft: 963, personnel: 167 },
    { day: 11, sqft: 1570, personnel: 165 },
    { day: 12, sqft: 1512, personnel: 146 },
    { day: 13, sqft: 621, personnel: 157 },
    { day: 14, sqft: 846, personnel: 140 },
    { day: 17, sqft: 1069, personnel: 158 },
    { day: 18, sqft: 1547, personnel: 142 },
    { day: 19, sqft: 1025, personnel: 155 },
    { day: 20, sqft: 1237, personnel: 159 },
    { day: 21, sqft: 829, personnel: 169 },
    { day: 24, sqft: 636, personnel: 161 },
    { day: 25, sqft: 1039, personnel: 160 },
    { day: 26, sqft: 1361, personnel: 148 },
    { day: 27, sqft: 630, personnel: 168 },
    { day: 28, sqft: 1553, personnel: 153 },
    { day: 31, sqft: 1055, personnel: 148 },
  ],
  "2025-3": [
    { day: 1, sqft: 1551, personnel: 166 },
    { day: 2, sqft: 870, personnel: 164 },
    { day: 3, sqft: 1510, personnel: 163 },
    { day: 4, sqft: 1093, personnel: 150 },
    { day: 7, sqft: 1375, personnel: 141 },
    { day: 8, sqft: 1289, personnel: 169 },
    { day: 9, sqft: 717, personnel: 160 },
    { day: 10, sqft: 1082, personnel: 157 },
    { day: 11, sqft: 1100, personnel: 148 },
    { day: 14, sqft: 1389, personnel: 153 },
    { day: 15, sqft: 610, personnel: 164 },
    { day: 16, sqft: 673, personnel: 165 },
    { day: 17, sqft: 1519, personnel: 167 },
    { day: 18, sqft: 1283, personnel: 165 },
    { day: 21, sqft: 743, personnel: 162 },
    { day: 22, sqft: 612, personnel: 160 },
    { day: 23, sqft: 1027, personnel: 161 },
    { day: 24, sqft: 760, personnel: 166 },
    { day: 25, sqft: 1063, personnel: 144 },
    { day: 28, sqft: 606, personnel: 167 },
    { day: 29, sqft: 1100, personnel: 150 },
    { day: 30, sqft: 619, personnel: 147 },
  ],
  "2025-4": [
    { day: 1, sqft: 1358, personnel: 144 },
    { day: 2, sqft: 1446, personnel: 145 },
    { day: 5, sqft: 1495, personnel: 155 },
    { day: 6, sqft: 1357, personnel: 162 },
    { day: 7, sqft: 1493, personnel: 169 },
    { day: 8, sqft: 932, personnel: 141 },
    { day: 9, sqft: 1262, personnel: 149 },
    { day: 12, sqft: 1119, personnel: 165 },
    { day: 13, sqft: 1467, personnel: 163 },
    { day: 14, sqft: 1308, personnel: 158 },
    { day: 15, sqft: 1104, personnel: 143 },
    { day: 16, sqft: 1228, personnel: 155 },
    { day: 19, sqft: 1440, personnel: 144 },
    { day: 20, sqft: 713, personnel: 159 },
    { day: 21, sqft: 716, personnel: 158 },
    { day: 22, sqft: 1385, personnel: 160 },
    { day: 23, sqft: 1120, personnel: 160 },
    { day: 27, sqft: 1007, personnel: 148 },
    { day: 28, sqft: 1589, personnel: 160 },
    { day: 29, sqft: 1357, personnel: 169 },
    { day: 30, sqft: 1148, personnel: 145 },
  ],
  "2025-5": [
    { day: 2, sqft: 1014, personnel: 145 },
    { day: 3, sqft: 636, personnel: 160 },
    { day: 4, sqft: 863, personnel: 160 },
    { day: 5, sqft: 1412, personnel: 151 },
    { day: 6, sqft: 1038, personnel: 151 },
    { day: 9, sqft: 917, personnel: 154 },
    { day: 10, sqft: 1288, personnel: 141 },
    { day: 11, sqft: 1257, personnel: 144 },
    { day: 12, sqft: 822, personnel: 165 },
    { day: 13, sqft: 1513, personnel: 149 },
    { day: 16, sqft: 1234, personnel: 142 },
    { day: 17, sqft: 1145, personnel: 163 },
    { day: 18, sqft: 916, personnel: 148 },
    { day: 19, sqft: 1344, personnel: 148 },
    { day: 20, sqft: 640, personnel: 170 },
    { day: 23, sqft: 1132, personnel: 161 },
    { day: 24, sqft: 697, personnel: 168 },
    { day: 25, sqft: 1560, personnel: 158 },
    { day: 26, sqft: 1511, personnel: 145 },
    { day: 27, sqft: 1328, personnel: 149 },
    { day: 30, sqft: 990, personnel: 165 },
  ],
  "2025-6": [
    { day: 1, sqft: 1123, personnel: 141 },
    { day: 2, sqft: 659, personnel: 144 },
    { day: 3, sqft: 1046, personnel: 166 },
    { day: 7, sqft: 814, personnel: 149 },
    { day: 8, sqft: 1434, personnel: 152 },
    { day: 9, sqft: 1324, personnel: 147 },
    { day: 10, sqft: 1381, personnel: 143 },
    { day: 11, sqft: 1072, personnel: 152 },
    { day: 14, sqft: 677, personnel: 157 },
    { day: 15, sqft: 659, personnel: 164 },
    { day: 16, sqft: 902, personnel: 146 },
    { day: 17, sqft: 636, personnel: 155 },
    { day: 18, sqft: 946, personnel: 148 },
    { day: 21, sqft: 833, personnel: 146 },
    { day: 22, sqft: 1459, personnel: 148 },
    { day: 23, sqft: 1309, personnel: 147 },
    { day: 24, sqft: 736, personnel: 142 },
    { day: 25, sqft: 793, personnel: 169 },
    { day: 28, sqft: 749, personnel: 140 },
    { day: 29, sqft: 1561, personnel: 161 },
    { day: 30, sqft: 1075, personnel: 146 },
    { day: 31, sqft: 1506, personnel: 141 },
  ],
  "2025-7": [
    { day: 1, sqft: 1318, personnel: 144 },
    { day: 4, sqft: 945, personnel: 159 },
    { day: 5, sqft: 1069, personnel: 145 },
    { day: 6, sqft: 1316, personnel: 148 },
    { day: 7, sqft: 1475, personnel: 149 },
    { day: 8, sqft: 1413, personnel: 161 },
    { day: 11, sqft: 628, personnel: 142 },
    { day: 12, sqft: 1209, personnel: 141 },
    { day: 13, sqft: 1259, personnel: 161 },
    { day: 14, sqft: 680, personnel: 144 },
    { day: 15, sqft: 1009, personnel: 158 },
    { day: 18, sqft: 908, personnel: 153 },
    { day: 19, sqft: 1355, personnel: 145 },
    { day: 20, sqft: 611, personnel: 153 },
    { day: 21, sqft: 834, personnel: 161 },
    { day: 22, sqft: 756, personnel: 153 },
    { day: 25, sqft: 968, personnel: 168 },
    { day: 26, sqft: 1134, personnel: 158 },
    { day: 27, sqft: 1257, personnel: 170 },
    { day: 28, sqft: 1090, personnel: 157 },
    { day: 29, sqft: 1340, personnel: 165 },
  ],
  "2025-8": [
    { day: 2, sqft: 635, personnel: 154 },
    { day: 3, sqft: 1046, personnel: 141 },
    { day: 4, sqft: 1405, personnel: 156 },
    { day: 5, sqft: 767, personnel: 155 },
    { day: 8, sqft: 1592, personnel: 164 },
    { day: 9, sqft: 1395, personnel: 157 },
    { day: 10, sqft: 1022, personnel: 146 },
    { day: 11, sqft: 637, personnel: 140 },
    { day: 12, sqft: 1358, personnel: 161 },
    { day: 15, sqft: 991, personnel: 148 },
    { day: 16, sqft: 1477, personnel: 144 },
    { day: 17, sqft: 1166, personnel: 163 },
    { day: 18, sqft: 722, personnel: 140 },
    { day: 19, sqft: 701, personnel: 146 },
    { day: 22, sqft: 688, personnel: 154 },
    { day: 23, sqft: 679, personnel: 168 },
    { day: 24, sqft: 830, personnel: 158 },
    { day: 25, sqft: 1247, personnel: 147 },
    { day: 26, sqft: 673, personnel: 155 },
    { day: 29, sqft: 1156, personnel: 153 },
    { day: 30, sqft: 633, personnel: 143 },
  ],
  "2025-9": [
    { day: 1, sqft: 655, personnel: 165 },
    { day: 2, sqft: 1488, personnel: 166 },
    { day: 3, sqft: 1536, personnel: 143 },
    { day: 6, sqft: 1462, personnel: 153 },
    { day: 7, sqft: 1551, personnel: 143 },
    { day: 8, sqft: 876, personnel: 163 },
    { day: 9, sqft: 744, personnel: 166 },
    { day: 10, sqft: 1312, personnel: 154 },
    { day: 13, sqft: 919, personnel: 145 },
    { day: 14, sqft: 1447, personnel: 157 },
    { day: 15, sqft: 1154, personnel: 155 },
    { day: 16, sqft: 951, personnel: 157 },
    { day: 17, sqft: 1279, personnel: 142 },
    { day: 20, sqft: 876, personnel: 144 },
    { day: 21, sqft: 740, personnel: 157 },
    { day: 22, sqft: 1584, personnel: 153 },
    { day: 23, sqft: 829, personnel: 164 },
    { day: 24, sqft: 1041, personnel: 154 },
    { day: 27, sqft: 700, personnel: 160 },
    { day: 28, sqft: 797, personnel: 143 },
    { day: 29, sqft: 1296, personnel: 156 },
    { day: 30, sqft: 1015, personnel: 140 },
    { day: 31, sqft: 1586, personnel: 152 },
  ],
  "2025-10": [
    { day: 3, sqft: 1123, personnel: 161 },
    { day: 4, sqft: 1213, personnel: 153 },
    { day: 5, sqft: 634, personnel: 166 },
    { day: 6, sqft: 1314, personnel: 162 },
    { day: 7, sqft: 1517, personnel: 145 },
    { day: 10, sqft: 877, personnel: 141 },
    { day: 11, sqft: 1369, personnel: 149 },
    { day: 12, sqft: 1556, personnel: 140 },
    { day: 13, sqft: 656, personnel: 164 },
    { day: 14, sqft: 701, personnel: 155 },
    { day: 17, sqft: 1280, personnel: 152 },
    { day: 18, sqft: 1047, personnel: 157 },
    { day: 19, sqft: 769, personnel: 156 },
    { day: 20, sqft: 1451, personnel: 149 },
    { day: 21, sqft: 1519, personnel: 166 },
    { day: 24, sqft: 1281, personnel: 160 },
    { day: 25, sqft: 1179, personnel: 168 },
    { day: 26, sqft: 1030, personnel: 170 },
    { day: 28, sqft: 1487, personnel: 143 },
  ],
  "2025-11": [
    { day: 1, sqft: 723, personnel: 157 },
    { day: 2, sqft: 1243, personnel: 144 },
    { day: 3, sqft: 786, personnel: 152 },
    { day: 4, sqft: 1333, personnel: 161 },
    { day: 5, sqft: 937, personnel: 154 },
    { day: 8, sqft: 1324, personnel: 144 },
    { day: 9, sqft: 1287, personnel: 167 },
    { day: 10, sqft: 1225, personnel: 166 },
    { day: 11, sqft: 1520, personnel: 146 },
    { day: 12, sqft: 668, personnel: 153 },
    { day: 15, sqft: 661, personnel: 147 },
    { day: 16, sqft: 1091, personnel: 163 },
    { day: 17, sqft: 729, personnel: 149 },
    { day: 18, sqft: 783, personnel: 165 },
    { day: 19, sqft: 651, personnel: 168 },
    { day: 22, sqft: 944, personnel: 156 },
    { day: 23, sqft: 1600, personnel: 144 },
    { day: 24, sqft: 1461, personnel: 167 },
    { day: 29, sqft: 1020, personnel: 157 },
    { day: 30, sqft: 924, personnel: 166 },
    { day: 31, sqft: 1365, personnel: 168 },
  ],
  "2026-0": Array.from({ length: 23 }, (_, i) => ({
    day: i + 1,
    sqft: Math.round(600 + Math.random() * 400),
    personnel: Math.round(35 + Math.random() * 10),
  })),
  "2026-1": Array.from({ length: 20 }, (_, i) => ({
    day: i + 1,
    sqft: Math.round(650 + Math.random() * 400),
    personnel: Math.round(36 + Math.random() * 10),
  })),
  "2026-2": [
    { day: 3, sqft: 812, personnel: 38 },
    { day: 4, sqft: 960, personnel: 41 },
    { day: 5, sqft: 748, personnel: 37 },
    { day: 6, sqft: 693, personnel: 35 },
    { day: 7, sqft: 874, personnel: 39 },
    { day: 10, sqft: 920, personnel: 40 },
    { day: 11, sqft: 980, personnel: 42 },
    { day: 12, sqft: 770, personnel: 38 },
    { day: 13, sqft: 860, personnel: 39 },
    { day: 14, sqft: 630, personnel: 36 },
    { day: 17, sqft: 910, personnel: 41 },
    { day: 18, sqft: 990, personnel: 43 },
    { day: 19, sqft: 840, personnel: 40 },
    { day: 20, sqft: 780, personnel: 38 },
    { day: 21, sqft: 720, personnel: 37 },
    { day: 24, sqft: 870, personnel: 40 },
    { day: 25, sqft: 930, personnel: 42 },
    { day: 26, sqft: 800, personnel: 39 },
    { day: 27, sqft: 820, personnel: 40 },
    { day: 28, sqft: 564, personnel: 34 },
  ],
  "2026-3": Array.from({ length: 22 }, (_, i) => ({
    day: i + 1,
    sqft: Math.round(700 + Math.random() * 450),
    personnel: Math.round(38 + Math.random() * 8),
  })),
  "2026-4": Array.from({ length: 22 }, (_, i) => ({
    day: i + 1,
    sqft: Math.round(750 + Math.random() * 400),
    personnel: Math.round(39 + Math.random() * 8),
  })),
};

export const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const MONTH_NAMES_SHORT = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
